'use strict';

// LOAN-490: Contentful content is served from static snapshots (see classes/StaticContentful.js
// and scripts/snapshot-contentful.js). These objects only select which snapshot folder a
// component reads from. The keys match the ones the old Contentful client expected.

// Legacy "Mogo" space content (page entries, feedback dialog, cross promos).
var ContentfulSpaceParams = {
  environment_id: 'Mogo'
};

// App content (interstitials, educational, legal disclaimers, generic layouts, action panels).
var ContentfulAppSpaceParams = {
  environment_id: 'master'
};